import {
  ADD_CHAPTER_COMMENT_FAILURE,
  ADD_CHAPTER_COMMENT_REQUEST,
  ADD_CHAPTER_COMMENT_SUCCESS,
  ADD_COMMENT_REPLY_FAILURE,
  ADD_COMMENT_REPLY_REQUEST,
  ADD_COMMENT_REPLY_SUCCESS,
  GET_CHAPTER_COMMENTS_FAILURE,
  GET_CHAPTER_COMMENTS_REQUEST,
  GET_CHAPTER_COMMENTS_SUCCESS,
  RESET_ALL_COMMENT_STATE,
} from "./ActionType";

const initialState = {
  chapterComments: {},
  loadingChapterComments: false,
  errorChapterComments: null,

  addCommentLoading: false,
  addCommentError: null,
  addCommentResult: false,

  addReplyLoading: false,
  addReplyError: null,
  addReplyResult: false,
};

export const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHAPTER_COMMENTS_REQUEST:
      return {
        ...state,
        loadingChapterComments: true,
        errorChapterComments: null,
      };
    case GET_CHAPTER_COMMENTS_SUCCESS:
      return {
        ...state,
        loadingChapterComments: false,
        chapterComments: action.payload,
      };
    case GET_CHAPTER_COMMENTS_FAILURE:
      return {
        ...state,
        loadingChapterComments: false,
        errorChapterComments: action.error,
      };
    case ADD_CHAPTER_COMMENT_REQUEST:
      return {
        ...state,
        addCommentLoading: true,
        addCommentError: null,
      };
    case ADD_CHAPTER_COMMENT_SUCCESS:
      return {
        ...state,
        addCommentLoading: false,
        addCommentResult: true,
      };
    case ADD_CHAPTER_COMMENT_FAILURE:
      return {
        ...state,
        addCommentLoading: false,
        addCommentError: action.error,
      };
    case ADD_COMMENT_REPLY_REQUEST:
      return {
        ...state,
        addReplyLoading: true,
        addReplyError: null,
      };

    case ADD_COMMENT_REPLY_SUCCESS:
      return {
        ...state,
        addReplyLoading: false,
        addReplyResult: true,
      };

    case ADD_COMMENT_REPLY_FAILURE:
      return {
        ...state,
        addReplyLoading: false,
        addReplyError: action.error,
      };
    case RESET_ALL_COMMENT_STATE:
      return {
        ...state,
        chapterComments: {},
        loadingChapterComments: false,
        errorChapterComments: null,

        addCommentLoading: false,
        addCommentError: null,
        addCommentResult: false,

        addReplyLoading: false,
        addReplyError: null,
        addReplyResult: false,
      };

    default:
      return state;
  }
};
